import axios from 'axios'
import React from 'react'

const AddedProducts = ({data,removeProduct}) => {
  return (
    <div className="rounded overflow-hidden shadow-lg">
    <img className="w-full" src={data.images[0]} alt="Mountain"/>
    <div className="px-6 py-4">
      <div className="font-bold text-xl mb-2">{data.name}</div>
      <p className="text-black font-bold align-content-sm-start">
        Rs {data.price}
      </p>
    </div>
    <div className="px-2 pt-5 ">
      <span className="inline-block bg-gray-500 px-3 rounded py-1 text-sm font-semibold text-white mr-2 mb-2 cursor:pointer">{data.category}</span>
      <span className="inline-block bg-blue-500 rounded px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-blue-700">{data.delivery} days</span>
    </div>
    <div className="px-2 pt-5 ">
      <span className="inline-block bg-red-500 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2 hover:bg-red-700 cursor:pointer" onClick={() => removeProduct(data._id)}>Remove</span>
    </div>
  </div>

  )
}

export default AddedProducts